module.exports = __webpack_public_path__ + "img/sync-desc-1.950b19b7.png";